/**
 * Thin factory for Wave 2–4 marketing pages that follow the Apple/Stripe pattern:
 * hero → founder video → points → quote → standard CTA.
 * Agents expand copy; this keeps structure consistent.
 */
export function marketingPageMeta({ title, description, path }) {
  return {
    title,
    meta: [
      { name: 'description', content: description },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: 'https://www.improve.online/static/SEO.png' },
      { property: 'og:url', content: 'https://www.improve.online' + path },
    ],
    link: [{ rel: 'canonical', href: 'https://www.improve.online' + path }],
  };
}
